export const environment = {
  production: true,
  apiUrl: 'https://producerportal-api.anzcofoods.com',
  webUrl: 'https://producerportal.anzcofoods.com',
  releaseVersion: 'BuildNo Prod: 20260513.1',
  advantageUrl: 'https://www.anzcoadvantage.com',
  raygunKey: 'DYZ5UBurf1ABgZcckLQeTg',
};
